/**
 *
 * PageLoadingComponent Component
 *
 */

import { stylize } from "@envestnet/envreact-component-library";
import classnames from "classnames";
import CentricLayout from "components/CentricLayout";
import Logo from "images/Logo";
import React from "react";
import withIntl from "utils/withIntl";
import messages from "./messages";
import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;

  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;
}

export interface PageLoadingComponentProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;

  /** When true, loading screen covers the full browser viewport */
  isFullPage?: boolean;
}

type Props = InjectedProps & PageLoadingComponentProps;

const PageLoadingComponent = (props: Props) => {
  const { classes, style, className, formatMessage, innerRef, isFullPage } =
    props;

  return (
    <div
      ref={innerRef}
      className={classnames(className, classes.container, {
        [classes.fullPageContainer]: isFullPage,
      })}
      style={style}
    >
      <CentricLayout>
        <>
          <Logo />
          <div className={classes.loadingText}>
            {formatMessage(messages.loadingText)}
          </div>
          <div className={classes.loaderOuter}>
            <div className={classes.loader}>
              <span className={classnames(classes.dot, classes.dot1)}></span>
              <span className={classnames(classes.dot, classes.dot2)}></span>
              <span className={classnames(classes.dot, classes.dot3)}></span>
            </div>
          </div>
        </>
      </CentricLayout>
    </div>
  );
};

export default withIntl(stylize<Props>(styles)(PageLoadingComponent));
